import { render, staticRenderFns } from "./editList1.vue?vue&type=template&id=a2058950"
import script from "./editList1.vue?vue&type=script&lang=js"
export * from "./editList1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports